module.exports = __webpack_public_path__ + "img/start-onboarding.0b2cfe76.jpg";